import TextHelpers from './text-helpers';
import TextDomSetter from './text-dom-setter';
import TextRenderer from './text-renderer';
import StringRenderer from './string-renderer';
import AbstractElement from './abstractElement';
import Textarea from './textarea';
import Text from './text';
import TextColumn from './text-column';
import Span from './span';
import String from './string';
import LinkedTextNode from './text-overflow/linked-text-node';
import LinkedTextList from './text-overflow/linked-text-list';

export const PartialStylingAttributes = [
  'baseline-shift',
  'custom-font-id',
  'font-stretch',
  'data-paragraph-style',
  'data-meta',
  'fill',
  'font-family',
  'font-size',
  'font-style',
  'font-weight',
  'highlight',
  'link',
  'text-decoration',
  'x',
  'custom-placeholder',
  'data-defined-placeholder'
];

export default () => ({
  _cache: {},
  Helpers: TextHelpers(),
  AbstractElement,
  Textarea,
  TextDomSetter,
  TextRenderer,
  StringRenderer,
  Text,
  TextColumn,
  Span,
  String,
  LinkedTextNode,
  LinkedTextList
});
